import type { FaireProductEntity } from "../../entity_types/product";

export const p_rzrea8zdj4: FaireProductEntity = {
  token: "p_rzrea8zdj4",
  type: "product",
  name: "Sauce Bae x Memphis May Fire Hot Sauce",
  brandToken: "b_244fxqfjt6",
  brandName: "Sauce Bae",
  imageUrl:
    "https://cdn.faire.com/fastly/0ab9d8628e492a208a70f99bb607c25149aa7adcc5560fedb3a8bb22d3da43c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f67d6162accee605a2d1bfc1959e062a99406c171aa62d66c56ae94692c8471b.jpeg",
    "https://cdn.faire.com/fastly/a6ccea5da114da8c44a1ccf4577537a89bc363dea46ebe86674df3a991ddff09.jpeg",
    "https://cdn.faire.com/fastly/d82b81a07c83e3c68d8b53b1cf6961aa8b9dc0d8a82845fcc2173aee26b2527f.jpeg",
    "https://cdn.faire.com/fastly/c88d753ed2559416c353a4e012709ba8a5ffaed3ff7c4fa5d3155b73e261d9b6.jpeg",
    "https://cdn.faire.com/fastly/dce1157b3ec64c0959eb496b37c30c37b02f2548c171828b49fab409d0d109cb.jpeg",
    "https://cdn.faire.com/fastly/e5e2306241c650fbfca334634f3709903fee7d90cc0f83115b194ab932ee6900.jpeg",
    "https://cdn.faire.com/fastly/a3899f6306b1a098139d1552abe035ed9cf7ce81fe413de73f06ea5ac63a58ea.jpeg",
    "https://cdn.faire.com/fastly/c0484bdf51b97df22917ced506bb646b77a7a1d9130834fb4e035dcee388d88f.jpeg",
    "https://cdn.faire.com/fastly/a90a7bee43d02f39f59378579af210b5cb66e47a227c1cbf5c5460fdfe74206f.jpeg",
  ],
  priceDollars: 4.48,
  description:
    "Unleash the heat of Memphis May Fire with this electrifying tomatillo-agave hot sauce!\n\nInspired by the band’s hard-hitting sound, this sauce hits all the right notes....sweet, spicy, and bold! It’s the ultimate condiment for amping up chicken tacos, wings, and your favorite recipes.\n\nA perfect harmony of tomatillo, lime, and a combo of serrano pepper and habanero heat, balanced by the smooth sweetness of blue agave and parsley. With a heat level of 6/10, it’s just hot enough to spice up your meals without overpowering the flavor. Get ready to bring your taste buds to the mosh pit!\n\nHEAT: 🔥 Hot (6/10)\n\n🍋 🟩 Tomatillo, Blue Agave & Lime Base\n🌶️ Only Real Ingredients\n🧂 Low Sodium\n❌ No Xanthan Gum!\n\nSize: 5 fl oz",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:10.215Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
